<div class="participant-details-container">
    <div class="main-score">
        @if (isNewEDPScoreboard) {
            <div class="event-header-live">
                <i class="live-icon"></i>
                <ms-event-timer [live]="event.live" [start]="event.startDate" [scoreboard]="event.scoreboard" [timeValue]="timeValue" />
                @if (!!yardDistance && (turn === 1 || turn === 2)) {
                    <span
                        >&nbsp;• <span class="period-header">{{ yardDistance }}</span></span
                    >
                }
            </div>
        } @else {
            <div class="header">
                <div class="event-score">
                    <div class="score-container" [ngClass]="{ inactive: vm.eventSuspended }">
                        <ms-score-card
                            [eventId]="event.id"
                            [participant1Score]="vm.score[0].toString()"
                            [participant2Score]="vm.score[1].toString()" />
                    </div>
                    @if (vm.showPenalties) {
                        <span>{{ sitecoreEventDetails.eventDetails.OTEnded }}</span>
                    } @else {
                        <ms-event-timer class="period-name" [live]="event.live" [start]="event.startDate" [scoreboard]="event.scoreboard" />
                    }
                </div>
            </div>
        }

        @for (participant of event.participants; track participant; let i = $index) {
            <div class="participant">
                <ms-participant-image
                    class="participant-logo"
                    [participantImage]="event.participants[i].image"
                    [sportId]="event.sport.id"
                    [shouldRotate]="rotateImage[i]"
                    [showLogoColor]="showLogoColor" />
                <div class="participant-details">
                    <ms-scoreboard-participant
                        class="participant-info"
                        [showIndicator]="false"
                        [event]="event"
                        [participant]="event.participants[i]"
                        [isNewEDPScoreboard]="isNewEDPScoreboard"
                        [participantInfo]="participantInfos && participantInfos[i]" />
                    @if (homeTeamTimeouts !== undefined && awayTeamTimeouts !== undefined) {
                        <div class="timeout-left" [class.has-ranks]="participantInfos && !!participantInfos[i].rank">
                            @if (i === 0) {
                                <div class="home-team-time-outs">
                                    @for (timeout of [1, 2, 3]; track timeout) {
                                        <div class="timeout" [ngClass]="{ inactive: timeout > homeTeamTimeouts }"></div>
                                    }
                                </div>
                            }
                            @if (i === 1) {
                                <div class="away-team-time-outs">
                                    @for (timeout of [1, 2, 3]; track timeout) {
                                        <div class="timeout" [ngClass]="{ inactive: timeout > awayTeamTimeouts }"></div>
                                    }
                                </div>
                            }
                        </div>
                    }
                    @if (vm.showPenaltie && isNewEDPScoreboard) {
                        <div class="penalty-shootout-container">
                            <div class="penalty-shootout-score">
                                <div class="penalty-score">
                                    <ms-penalty-shootout class="penalty-shootout" [penalties]="vm.penalties[i]" />
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        }
    </div>
</div>

<ms-period-game-scoreboard-live [scoreboard]="scoreboard" [event]="event" [isNewEDPScoreboard]="isNewEDPScoreboard" />
